/*
 * WOWSCENT rep referral capture for the Shopify storefront.
 * Install as a theme asset and load from theme.liquid <head> (defer).
 *
 * Config is read from window.WOWSCENT_REP_CONFIG (set in theme.liquid) so the
 * same file works on a *.myshopify.com test theme and on the live domain.
 *
 * Rules implemented:
 *  - first valid rep wins for 30 days; an unexpired attribution is never replaced
 *  - purchases do not extend the window
 *  - the signed token is copied onto every cart, including Buy Now / Shop Pay /
 *    Apple Pay / Google Pay via hidden product-form line-item properties
 *  - all validation is authoritative server-side in the paid-order webhook
 */
(function () {
  var CFG = window.WOWSCENT_REP_CONFIG || {};
  var STORE = String(CFG.store || "wowscent").toLowerCase();
  var IS_LEGACY = STORE === "wowscent";
  var API = (CFG.apiBase || "https://repwowscent.co.uk") + "/api/public/rep/validate";
  var COOKIE_DOMAIN = CFG.cookieDomain || ""; // empty = current host (correct for *.myshopify.com)
  var DEBUG = !!CFG.debug;
  // WOW Scent keeps its original key names so existing 30-day sessions are
  // never disturbed; every other store gets its own namespace.
  var KEY = IS_LEGACY ? "wowscent.rep.attribution" : STORE + ".rep.attribution";
  var COOKIE = IS_LEGACY ? "wowscent_rep" : STORE + "_rep";
  var MAX_AGE = 30 * 24 * 60 * 60;


  function log() {
    if (DEBUG && window.console) console.log.apply(console, ["[wowscent-rep]"].concat([].slice.call(arguments)));
  }

  function readCookie(name) {
    var m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
    return m ? decodeURIComponent(m[2]) : null;
  }
  function writeCookie(name, value) {
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      ";path=/;max-age=" +
      MAX_AGE +
      (COOKIE_DOMAIN ? ";domain=" + COOKIE_DOMAIN : "") +
      ";samesite=lax;secure";
  }
  function load() {
    var raw = null;
    try {
      raw = localStorage.getItem(KEY);
    } catch (e) {}
    raw = raw || readCookie(COOKIE);
    if (!raw) return null;
    try {
      var a = JSON.parse(raw);
      if (!a || !(a.expiresAt > Date.now())) return null;
      // Never reuse an attribution minted for a different storefront.
      var stored = String(a.store || "wowscent").toLowerCase();
      if (stored !== STORE) return null;
      return a;
    } catch (e) {
      return null;
    }

  }
  function save(a) {
    var raw = JSON.stringify(a);
    try {
      localStorage.setItem(KEY, raw);
    } catch (e) {}
    writeCookie(COOKIE, raw);
  }

  function codeFromUrl() {
    var path = window.location.pathname.match(/^\/(?:rep|pages\/rep)\/([A-Za-z0-9_-]{2,40})\/?$/);
    if (path) return path[1];
    var params = new URLSearchParams(window.location.search);
    var q = params.get("ref") || params.get("code");
    return q && /^[A-Za-z0-9_-]{2,40}$/.test(q) ? q : null;
  }

  function attrsFrom(a) {
    return {
      _rep_code: a.code,
      _rep_application_id: a.applicationId,
      _rep_captured_at: String(a.capturedAt),
      _rep_expires_at: String(a.expiresAt),
      _rep_token: a.token,
    };
  }

  function stampForms(attrs) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      (function (form) {
        Object.keys(attrs).forEach(function (k) {
          var name = "properties[" + k + "]";
          if (form.querySelector('[name="' + name + '"]')) return;
          var input = document.createElement("input");
          input.type = "hidden";
          input.name = name;
          input.value = attrs[k];
          form.appendChild(input);
        });
      })(forms[i]);
    }
  }

  function applyToCart(a) {
    var attrs = attrsFrom(a);

    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes: attrs }),
    })
      .then(function () {
        log("cart attributes written", attrs);
      })
      .catch(function () {});

    // Accelerated checkout (Buy Now / Shop Pay / Apple Pay / Google Pay) skips
    // the cart, so the same values ride along as line-item properties.
    stampForms(attrs);
    // Re-stamp for themes that inject product forms later (quick view, sections API).
    if (window.MutationObserver) {
      new MutationObserver(function () {
        stampForms(attrs);
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  // ---- Informational banner (presentational only) -------------------------
  var BANNER_ID = "wowscent-rep-banner";
  var DISMISS_KEY = IS_LEGACY ? "wowscent.rep.bannerDismissed" : STORE + ".rep.bannerDismissed";
  var ACCENT = CFG.accent || "#d4af37";
  var BANNER_TEXT = CFG.bannerText || "Shopping with";
  // "first" (default, WOW Scent behaviour) or "full" (Bubbles).
  var NAME_STYLE = String(CFG.nameStyle || "first").toLowerCase() === "full" ? "full" : "first";


  function firstName(name) {
    return String(name || "your rep").trim().split(/\s+/)[0];
  }

  function fullName(name) {
    return String(name || "your rep").trim().replace(/\s+/g, " ");
  }

  function displayName(name) {
    return NAME_STYLE === "full" ? fullName(name) : firstName(name);
  }


  function bannerAllowedHere() {
    var p = window.location.pathname || "";
    if (/^\/checkouts?(\/|$)/.test(p)) return false;
    if (/^\/\d+\/checkouts?(\/|$)/.test(p)) return false;
    if (/^\/apps\/(shop-pay|checkout)/.test(p)) return false;
    return true;
  }

  function renderBanner(a) {
    try {
      if (CFG.banner === false) return;
      if (!a || !a.code) return;
      if (!bannerAllowedHere()) return;
      if (document.getElementById(BANNER_ID)) return;
      try {
        if (sessionStorage.getItem(DISMISS_KEY) === "1") return;
      } catch (e) {}
      if (!document.body) {
        document.addEventListener("DOMContentLoaded", function () {
          renderBanner(a);
        });
        return;
      }

      var bar = document.createElement("div");
      bar.id = BANNER_ID;
      bar.setAttribute("role", "status");
      bar.style.cssText = [
        "position:fixed",
        "left:0",
        "right:0",
        "bottom:0",
        "z-index:2147483000",
        "background:#0a0a0a",
        "color:#f5f0e6",
        "border-top:1px solid " + ACCENT,
        "font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
        "font-size:13px",
        "line-height:1.35",
        "box-shadow:0 -2px 10px rgba(0,0,0,.28)",
        "padding-bottom:env(safe-area-inset-bottom,0px)",
        "pointer-events:none",
      ].join(";");

      var isNarrow = false;
      try {
        isNarrow = !!(window.matchMedia && window.matchMedia("(max-width:480px)").matches);
      } catch (e) {}

      var inner = document.createElement("div");
      inner.style.cssText = [
        "max-width:1200px",
        "margin:0 auto",
        isNarrow ? "padding:6px 10px" : "padding:9px 14px",
        "display:flex",
        "align-items:center",
        "justify-content:center",
        "gap:4px 10px",
        "flex-wrap:wrap",
        "text-align:center",
        "box-sizing:border-box",
      ].join(";");


      var who = document.createElement("span");
      who.appendChild(document.createTextNode(BANNER_TEXT + " "));
      var strong = document.createElement("strong");
      strong.textContent = displayName(a.name);
      strong.style.cssText = "color:" + ACCENT + ";font-weight:700";

      who.appendChild(strong);

      var codeEl = document.createElement("span");
      codeEl.style.cssText = "opacity:.8;font-size:12px;letter-spacing:.04em";
      codeEl.textContent = "Rep code: " + a.code;

      var close = document.createElement("button");
      close.type = "button";
      close.setAttribute("aria-label", "Dismiss rep banner");
      close.innerHTML = "&times;";
      close.style.cssText = [
        "pointer-events:auto",
        "background:transparent",
        "border:0",
        "color:#f5f0e6",
        "opacity:.7",
        "font-size:18px",
        "line-height:1",
        "cursor:pointer",
        "padding:0 2px",
        "margin-left:4px",
      ].join(";");
      close.addEventListener("click", function () {
        try {
          sessionStorage.setItem(DISMISS_KEY, "1");
        } catch (e) {}
        if (bar.parentNode) bar.parentNode.removeChild(bar);
      });

      inner.appendChild(who);
      inner.appendChild(codeEl);
      inner.appendChild(close);
      bar.appendChild(inner);
      document.body.appendChild(bar);
    } catch (e) {
      log("banner render failed", e);
    }
  }

  // Themes with view transitions / soft navigation (e.g. Horizon) swap the
  // page body without a reload, which removes the banner node. Re-render on
  // those events; renderBanner() is idempotent (guards by element id).
  function keepBannerMounted(a) {
    var rerender = function () {
      renderBanner(a);
    };
    ["page:loaded", "shopify:section:load", "pageshow", "popstate", "visibilitychange"].forEach(function (evt) {
      window.addEventListener(evt, rerender, { passive: true });
      document.addEventListener(evt, rerender, { passive: true });
    });
    if (window.MutationObserver && document.body) {
      new MutationObserver(function () {
        if (!document.getElementById(BANNER_ID)) rerender();
      }).observe(document.body, { childList: true });
    }
  }

  // ---- Floating rep photo (presentational only) ---------------------------
  // WOW Scent by default (other stores opt in with photo:true). Loads the rep's
  // photo by referral code; if the rep has no photo, nothing is shown.
  var PHOTO_ID = "wowscent-rep-photo";
  var PHOTO_API = (CFG.apiBase || "https://repwowscent.co.uk") + "/api/public/rep/photo";
  var photoUrlLoaded = null;
  function renderPhoto(a) {
    try {
      if (CFG.photo === false || (!IS_LEGACY && CFG.photo !== true)) return;
      if (!a || !a.code || !document.body) return;
      if (document.getElementById(PHOTO_ID)) return;
      var src = PHOTO_API + "?code=" + encodeURIComponent(a.code);
      var img = new Image();
      img.alt = "Shopping with " + firstName(a.name);
      img.onload = function () {
        if (document.getElementById(PHOTO_ID)) return;
        photoUrlLoaded = src;
        var wrap = document.createElement("div");
        wrap.id = PHOTO_ID;
        wrap.title = "Shopping with " + fullName(a.name);
        wrap.setAttribute("role", "img");
        wrap.setAttribute("aria-label", img.alt);
        wrap.style.cssText =
          "position:fixed;right:16px;bottom:16px;z-index:2147483000;width:72px;height:72px;" +
          "border-radius:50%;border:4px solid " + (CFG.photoBorder || "#f4a6c6") + ";overflow:hidden;" +
          "box-shadow:0 6px 18px rgba(0,0,0,.25);background:#fff;transition:transform .2s;";
        img.style.cssText = "width:100%;height:100%;object-fit:cover;display:block;";
        wrap.appendChild(img);
        wrap.addEventListener("mouseenter", function () { wrap.style.transform = "scale(1.08)"; });
        wrap.addEventListener("mouseleave", function () { wrap.style.transform = ""; });
        document.body.appendChild(wrap);
      };
      img.onerror = function () { log("no rep photo"); };
      img.src = photoUrlLoaded || src;
    } catch (e) {
      log("photo render failed", e);
    }
  }

  function activate(a) {
    window.wowscentRep = a;
    applyToCart(a);
    renderBanner(a);
    keepBannerMounted(a);
    renderPhoto(a);
    ["page:loaded", "shopify:section:load", "pageshow"].forEach(function (evt) {
      window.addEventListener(evt, function () { renderPhoto(a); });
      document.addEventListener(evt, function () { renderPhoto(a); });
    });
    log("active attribution", a);
    document.dispatchEvent(new CustomEvent("wowscent:rep-attributed", { detail: a }));
  }

  // ---- Rep-visitor guard --------------------------------------------------
  // WOW Scent only: a signed-in rep must never be attributed to a referral
  // link. The only reliable first-party signal on the storefront is the
  // Shopify customer email, injected as WOWSCENT_REP_CONFIG.customerEmail.
  // Other stores (Bubbles) allow reps to earn on their own purchases, so the
  // guard — and its is-rep network call — is skipped entirely there.
  var GUARD_SELF_REFERRAL = false;
  var IS_REP_API = (CFG.apiBase || "https://repwowscent.co.uk") + "/api/public/rep/is-rep";
  var REP_VISITOR_KEY = IS_LEGACY ? "wowscent.rep.visitor" : STORE + ".rep.visitor";

  function cachedRepVisitor(email) {
    try {
      var raw = sessionStorage.getItem(REP_VISITOR_KEY);
      if (!raw) return null;
      var c = JSON.parse(raw);
      return c && c.email === email ? c : null;
    } catch (e) {
      return null;
    }
  }

  function cacheRepVisitor(email, result) {
    try {
      sessionStorage.setItem(
        REP_VISITOR_KEY,
        JSON.stringify({ email: email, isRep: !!result.isRep, code: result.code || null }),
      );
    } catch (e) {}
  }

  /** Resolves { isRep, code }. Fails open (isRep:false) so customers are unaffected. */
  function checkRepVisitor() {
    if (!GUARD_SELF_REFERRAL) return Promise.resolve({ isRep: false, code: null });

    var email = String(CFG.customerEmail || "").trim().toLowerCase();
    if (!email || email.indexOf("@") === -1) return Promise.resolve({ isRep: false, code: null });

    var cached = cachedRepVisitor(email);
    if (cached) return Promise.resolve({ isRep: cached.isRep, code: cached.code });

    return fetch(IS_REP_API + "?email=" + encodeURIComponent(email), { credentials: "omit" })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var result = { isRep: !!(data && data.isRep), code: (data && data.code) || null };
        cacheRepVisitor(email, result);
        return result;
      })
      .catch(function (e) {
        log("rep-visitor check failed", e);
        return { isRep: false, code: null };
      });
  }

  function start(repVisitor) {
    var existing = load();
    if (existing) {
      // A rep already carrying someone else's attribution is never activated
      // or shown a banner; existing cart attributes are left untouched.
      if (repVisitor.isRep) {
        log("logged-in rep — existing attribution ignored", existing.code);
        return;
      }
      activate(existing);
      return;
    }

    var code = codeFromUrl();
    if (!code) return;

    if (repVisitor.isRep) {
      log("logged-in rep — refusing to capture referral", code);
      return;
    }

    log("looking up code", code);

    // WOW Scent keeps its original request shape (no store param → wowscent token).
    var url = API + "?code=" + encodeURIComponent(code) + (IS_LEGACY ? "" : "&store=" + encodeURIComponent(STORE));

    fetch(url, { credentials: "omit" })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.valid) {
          log("code rejected", data);
          return;
        }
        var tokenStore = String(data.store || "wowscent").toLowerCase();
        if (tokenStore !== STORE) {
          log("store mismatch — token discarded", tokenStore, STORE);
          return;
        }
        var a = {
          code: data.rep.code,
          name: data.rep.name,
          applicationId: data.applicationId || (data.rep && data.rep.applicationId) || "",
          store: tokenStore,
          capturedAt: data.capturedAt,
          expiresAt: data.expiresAt,
          token: data.token,
        };

        save(a);
        activate(a);
      })
      .catch(function (e) {
        log("validate failed", e);
      });
  }

  checkRepVisitor().then(start);
})();
